import { z } from 'zod';
import { AssetStructureSchema } from './asset';
import { MarketDataItemSchema } from './valuation-comparables';
import { StandardLandValueZoneSchema, ValuationLandSchema } from './valuation-property';
const CreateValuationMarketDataItemShape = MarketDataItemSchema.omit({ id: true }).shape;
export const CreateValuationMarketDataItemSchema = z.object(CreateValuationMarketDataItemShape);
const CreateStandardLandValueZoneShape = StandardLandValueZoneSchema.omit({
    index: true,
}).shape;
export const CreateStandardLandValueZoneSchema = z.object(CreateStandardLandValueZoneShape);
const CreateValuationAreaShape = ValuationLandSchema.shape.areas.element.pick({
    title: true,
    area_value: true,
    is_yielding: true,
    adjustment_factors: true,
    market_adjustment_factor: true,
}).shape;
export const CreateValuationAreaSchema = z.object(CreateValuationAreaShape);
const CreateAssetStructureShape = AssetStructureSchema.options[1]
    .pick({
    title: true,
    construction_year: true,
    floor_structure: true,
    construction_method: true,
    structure_condition: true,
    building_facilities: true,
    construction_style: true,
    underground_conversion_degree: true,
    roof_structure: true,
    gross_floor_area: true,
    living_area: true,
    usage_area: true,
})
    .extend({
    usage_type: z.union([
        AssetStructureSchema.options[0].shape.usage_type,
        AssetStructureSchema.options[3].shape.usage_type,
        AssetStructureSchema.options[4].shape.usage_type,
        AssetStructureSchema.options[5].shape.usage_type,
        AssetStructureSchema.options[6].shape.usage_type,
        AssetStructureSchema.options[7].shape.usage_type,
    ]),
    sub_usage_type: z.union([
        AssetStructureSchema.options[0].shape.sub_usage_type,
        AssetStructureSchema.options[1].shape.sub_usage_type,
        AssetStructureSchema.options[2].shape.sub_usage_type,
        AssetStructureSchema.options[3].shape.sub_usage_type,
        AssetStructureSchema.options[4].shape.sub_usage_type,
        AssetStructureSchema.options[5].shape.sub_usage_type,
        AssetStructureSchema.options[6].shape.sub_usage_type,
        AssetStructureSchema.options[7].shape.sub_usage_type,
    ]),
}).shape;
export const CreateAssetStructureSchema = z.object(CreateAssetStructureShape);
